import React, { useState } from 'react'
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifCheckbox,
} from '@ey-xd/motif-react'

export default function FreeTextDisclaimerModal({
  open,
  onAgree,
}: {
  open: boolean
  onAgree: () => void
}) {
  const [checked, setChecked] = useState(false)

  return (
    <MotifModal show={open} size="md" onClose={() => {}}>
      <MotifModalBody>
        <h2>Disclaimer</h2>
        <p>
          EY does not intentionally collect any sensitive personal data from you
          via the tool. The Tool's intention is not to process such information.
          Accordingly, you should not enter any unnecessary personal information
          or any sensitive personal data (including government identifiers such
          as tax file numbers or social security numbers/national identification
          numbers), client confidential information (except client entity
          names), audit secrets, state secrets, trade secrets, or anything that
          would violate professional secrecy or confidentiality rules or that
          would be considered abusive/irrelevant in the Tool.
        </p>
        <MotifCheckbox checked={checked} onChange={() => setChecked(!checked)}>
          I agree to the disclaimer
        </MotifCheckbox>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton disabled={!checked} onClick={onAgree} variant="primary">
          Continue
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  )
}
